export const formatNumber = (number) => {
    return number.replace(/ /g,'').replace(/^./, '')
}